import React, { useContext } from "react";
import PropTypes from "prop-types";

import UserPrefsContext from '../../../../context/UserPrefs/UserPrefsContext';
import { FormatAsPercentRounded } from '../../../../utils/Helpers/Format';
import Range from '../../../../components/shared/InputElements/Range';

const descriptionFn = val => FormatAsPercentRounded(val);

const SlidePublicChargingPercentage = ({
  id = "public-charging-percentage-range",
  label = "Portion of Public Charging",
  description = descriptionFn,
  ...rest
}) => {
  const userPrefs = useContext(UserPrefsContext);

  return (
    <Range
      id={id}
      value={userPrefs.get("publicChargingPercentage")}
      label={label}
      rangeMin={0}
      rangeMax={100}
      rangeStep={10}
      description={description}
      tooltip={"Charging EVs at home is most convenient and cost-effective. If you can’t, we estimate how often you will charge at public, paid chargers, to calculate how much you’ll spend on charging on the go."}
      handler={e => userPrefs.set({ publicChargingPercentage: e.target.value })}
      {...rest}
    />
  );
};

export default SlidePublicChargingPercentage;

SlidePublicChargingPercentage.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  description: PropTypes.func
};

